import { composeIO } from 'react-compose-io'
import { BotaoView } from './Botao.View'
import { botaoIO } from './Botao.IO'

export const Botao = composeIO(BotaoView, botaoIO)
